import { alpha, createTheme } from '@mui/material';
import { fontSize } from '@mui/system';

const customBreakpoints = {
  xs: 0,
  sm: 600,
  md: 768,
  lg: 1200,
  xl: 1600,
};

const theme = createTheme({
  breakpoints: {
    values: customBreakpoints,
  },
  typography: {
    fontFamily: 'Lato, sans-serif',
    h1: {
      fontSize: 26,
      fontWeight: 600,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 20,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 22,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 24,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 26,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 28,
      },
    },
    h2: {
      fontSize: 20,
      // fontWeight: 400,
      fontWeight: 500,
      letterSpacing: "0.1px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 18,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 20,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 22,
      },
    },
    h3: {
      fontSize: 22,
      fontWeight: 600,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 18,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 20,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 22,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 24,
      },
    },
    body_400: {
      fontSize: 14,
      fontWeight: 400,
      // letterSpacing: "0.28px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        // fontSize: 12,
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        // fontSize: 14,
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        // fontSize: 16,
        fontSize: 18,
      },
    },
    body_500: {
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
    },
    body_600: {
      fontSize: 18,
      fontWeight: 600,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 20,
      },
    },
    body_700: {
      fontSize: 18,
      // fontWeight: 400,
      fontWeight: 700,
      // letterSpacing: "0.36px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        // fontSize: 12,
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        // fontSize: 14,
        fontSize: 18,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        // fontSize: 16,
        fontSize: 24,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        // fontSize: 18,
        fontSize: 28,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        // fontSize: 20,
        fontSize: 34,
      },
    },
    subtitle_300: {
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
    },
    subtitle_400: {
      fontSize: 16,
      fontWeight: 400,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
    },
    subtitle_500: {
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: "0.28px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
    },
    subtitle_600: {
      fontSize: 12,
      fontWeight: 600,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
    },
    overline_400: {
      fontSize: 12,
      fontWeight: 400,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
    },
    overline_600: {
      fontSize: 14,
      fontWeight: 600,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
    },
  },
  palette: {
    common: {
      black: "#000000",
      white: "#FFFFFF",
      red: "#FF0000",
      lightBlack: '#5F5B60',
      secoundaryLite: '#9C9C9C',
      tooltipBg: '#FFFFF0'
    },
    primary: {
      50: "#faf7eb",  // Lightest shade (very light gold)
      100: "#efe0a3", // Lighter shade (light gold)
      200: "#9B8217", // Light shade (soft gold)
      500: "#AB932B", // desired primary color (gold)
      800: "#6e5d1c", // Darker shade (darker gold)
      900: "#433a0f"
    },
    success: {
      50: "#f7fcf9",  // A lighter, more pastel green
      100: "#c6efce",  // A soft, pale green
      500: "#117408",  // desired primary color,
      800: "#0a5c2d",  // A deeper, richer green
      900: "#034b23"   // A very dark, deep green
    },
    error: {
      50: "#feecf0",
      100: "#fbc5d0",
      500: "#FF4848",
      800: "#852538",
      900: "#651c2b"
    },
    warning: {
      50: "#fef4e6",
      100: "#fdddb3",
      500: "#f79009",
      800: "#884f05",
      900: "#683c04"
    },
    text: {
      // primary: '#111927',
      primary: '#000',
      secondary: '#6c737f',
      disabled: "rgba(108, 115, 127, 0.35)",
    },
    textDark: {
      primary: "#edf2f7",
      secondary: "#a0aec0",
      disabled: "rgba(237, 242, 247, 0.35)",
    },
    grey: {
      50: "#f4f5f7",
      100: "#dde1e5",
      200: "#ccd2d8",
      300: "#b5bec7",
      400: "#a7b1bc",
      500: "#919eab",
      600: "#84909c",
      700: "#677079",
      800: "#50575e",
      900: "#3d4248",
      A100: "#F3F3F3",
      A200: "#E8E8E8"
    },
    background: {
      default: "#f7f7f7",
      paper: "#FFFFFF"
    },
    customColors: {
      pastelGrey: '#CDCDCD',
      loginBackgrounblue: '#2057A6',
      cinder: "#0F131F",
      brownishRed: "#A8382D",
      seaShell: "#F1F1F1",
      lightGreyBlue: "#A6B6D0",
      lavender: "#E6E6E6",
      greyFourty: "#666666",
      codGrey: "#181818",
      cyanBlue: "#3C92DC",
      aumRed: "#FF5630",
      aumOrange: "#FFAB00",
      aumBlue: "#1E90FF",
      aumRedLight: "#FF56301F",
      aumOrangeLight: "#FFAB001F",
      aumBlueLight: '#1E90FF1F',
      brightCerulean: "#00B8D9",
      offGreen: '#E7FAF2',
      greenTeal: '#0ECB81',
      greenText: '#065536',
      hyperlinkBlue: '#e1e4e9ff',
    },
    stroke: {
      main: alpha('#833941', 0.7), // Default border color
      light: alpha('#833941', 0.5), // Lighten by reducing opacity
      dark: '#833941',  // Darken by increasing opacity (not recommended, use a better approach)
    },
    // pieChartColor: ['#692E34', '#833941', '#D9C2C4', "#ECE1E3", '#F3EBEC'],
    // pieChartColor: ['#692E34', '#7A3F4B', '#8F5A63', "#A67C7F", '#F3EBEC'],
    // pieChartColor: ['#692E34', '#733D43', '#7B444F', "#84625B", '#F3EBEC'],
    pieChartColor: ['#692E34', '#833941', '#8F5A63', "#A67C7F", '#F3EBEC'],
    red: {
      light: '#f3ebec',
      lightHover: '#ece1e3',
      lightActive: '#d9c2c4',
      normal: '#833941',
      normalHover: '#76333b',
      normalActive: '#692e34',
      dark: '#622b31',
      darkHover: '#4f2227',
      darkActive: '#3b1a1d',
      darker: '#2e1417'
    },
    dark: {
      500: "#333333"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#FFFFFF ',
          borderColor: '#000',
          borderRadius: '10px',
          fontWeight: 'bold',
          fontSize: '18px',
          paddingTop: "15px",
          paddingBottom: "15px",
          letterSpacing: "0.36px",
          textTransform: 'none',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Lato, sans-serif',
        },
      },
      defaultProps: {
        variantMapping: {
          body_400: 'p',
          body_500: 'p',
          body_600: 'p',
          body_700: 'p',
          subtitle_300: 'p',
          subtitle_400: 'p',
          subtitle_500: 'p',
          subtitle_600: 'p',
          overline_400: 'p',
          overline_600: 'p'
        },
      },
    },
    MuiTableSortLabel: {
      variants: [{
        props: { active: false },
        style: {
          color: '#000',
        },
      }],
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            color: '#333',
            fontSize: '14px',
          },
          '& .MuiTableRow-root td:first-child': {
            paddingLeft: '16px !important',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#AB932B !important',
          "& .MuiTableCell-head": {
            backgroundColor: '#AB932B !important',
            color: "#FFF !important",
            fontWeight: 600,
          },
          "& .MuiTableCell-head:hover": {
            backgroundColor: "#AB932B80 !important",
            color: "white !important"
          },
          '& .MuiTableSortLabel-root, .MuiTableSortLabel-icon, .MuiTableSortLabel-active ': {
            color: '#FFF !important',
          },
          '& .MuiTableSortLabel-root:hover': {
            color: '#FFF !important',
            backgroundColor: "#AB932B80 !important",
          },
          '& .MuiTableRow-root th:first-child': {
            paddingLeft: '16px !important'
          }
        }
      }
    }
  },
});

export default theme;
